import { useState, useEffect } from "react";

/**
 * Custom hook for responsive design - similar to MUI's useMediaQuery
 * @param {string} query - CSS media query string (e.g., "(max-width: 800px)")
 * @returns {boolean} - Whether the media query matches
 */
function useMediaQuery(query) {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(query);
    setMatches(media.matches);

    const listener = (e) => setMatches(e.matches);
    media.addEventListener("change", listener);

    return () => media.removeEventListener("change", listener);
  }, [query]);

  return matches;
}

export default useMediaQuery;
